require('./brokerBanner.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @ actions
const bannerActions = require('actions/bannerUpdate');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

//@constants
const {
    BANNER_TYPE_LINK,
} = require('constants/index');

class Banner extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
    }

    componentWillUnmount() {
        const topbarElement = document.querySelector('.openbank-topbar');

        topbarElement && (topbarElement.style.top = 0);
    }

    buildBanner() {
        const { immBanner } = this.props;

        const data = immBanner.get('data');
        const title = data.get('title');
        const description = this.buildDescription(data.get('description'));
        const lastElement = this.buildLastElement();

        return (
            <div>
                <div className="broker-banner__close-icon">
                    <i
                        className="icon-cerrar"
                        onClick={() => {
                            this.handleOnClick();
                        }}
                    />
                </div>
                <div className="broker-banner--wrapper">
                    <div className="broker-banner__title">
                        {title}
                    </div>
                    <div className="broker-banner__description">
                        {description}
                    </div>
                    {lastElement}
                </div>
            </div>
        );
    }

    buildDescription(description) {
        return description.map((descriptionElement) => {
            if (!descriptionElement.get('injected')) {
                return (
                    <FormattedTextWithComponents
                        value={descriptionElement.get('value')}
                        className="broker-banner__description"
                    />
                );
            } else {
                return (
                    <FormattedTextWithComponents
                        value={descriptionElement.get('value')}
                        injectedComponents={descriptionElement.get('injected').toJS()}
                        className="broker-banner__description"
                    />
                );
            }
        });
    }

    buildLastElement() {
        const { immBanner } = this.props;

        const data = immBanner.get('data');
        const bannerType = data.get("bannerType");
        switch (bannerType) {
            case BANNER_TYPE_LINK:
                return (
                    this.createLink()
                );
            default:
                return (
                    this.createSpan()
                );
        }
    }

    createLink() {
        const { immBanner } = this.props;

        const options = immBanner.get('data').get("optionsBannerType");
        const link = options.get("link");
        const linkName = options.get("linkName");

        return (
            <OKLink to={link} modifier="emphasize">
                {linkName}
            </OKLink>
        );
    }

    createSpan() {
        const { immBanner } = this.props;

        const options = immBanner.get('data').get("optionsBannerType");
        const text = options.get("text").toUpperCase();
        const modifier = options.get("modifier");
        const extraClass = options.get("extraClass");

        let spanClassNames = classNames(
            'broker-banner__last-element',
            {
                ['broker-banner__last-element--' + modifier]: !!modifier,
                [extraClass]: !!extraClass
            }
        );

        return (
            <span
                className={spanClassNames}
                onClick={this.handleOnClick}
            >
                {text}
            </span>
        );
    }

    handleOnClick() {
        this.props.bannerClose();
    }

    render() {
        const { immBanner } = this.props;

        const isClose = immBanner.get('isClose');
        let showBanner;
        const newClass = classNames(
            {
                'broker-banner__container': !isClose,
                'broker-banner__container--not-available': isClose
            }
        );

        if (!isClose) {
            showBanner = this.buildBanner();
        }

        return (
            <div className={`${newClass} app__broker-banner`}>
                {showBanner}
            </div>
        );
    }
}

Banner.propTypes = {
    immBanner: PropTypes.object,
    bannerClose: PropTypes.func,
};

module.exports.constructor = Banner;
module.exports.Banner = connect(
    state => ({
        immBanner: state.bannerUpdate
    }), {
        bannerClose: bannerActions.bannerClose,
    }
)(Banner);
